import React from 'react';
import style from './BankPayment.module.css'
import PrimaryCTA from '../../components/PrimaryCTA/PrimaryCTA';
import { Link } from 'react-router-dom';

// get trade. this calls the api for the current trade and shows pages based on order status.

// A page for order history etc will show up here as transactions status.

// notification design. db schema. and link. or route.
// expecting notifs for chats.
// new trades.
// completed trades.

// clear one notification.
// clear all notiifvations
// create a mew notif.

const BankPayment = props => {
	return (
		<div className={style.BankPayment}>
			<div className={style.PaymentDetails}>
				<span className={style.PaymentDetailsTitle}>
					You receive
				</span>

				<span className={style.PaymentDetailsText}>
					602.4 USDT
				</span>
			</div>

			<div className={style.PaymentDetails}>
				<span className={style.PaymentDetailsTitle}>
					Transfer
				</span>

				<span className={style.PaymentDetailsText}>
					N 1 000 000.00
				</span>

				<span className={style.PaymentDetails}>
					To the account below and click on confirm to proceed
				</span>
			</div>

			<div>
				<div className={style.DetailsText}>
					<span className={style.DetailsHeading}>
						Bank Details
					</span>

					<div className={style.AccountDetailsTextWrapper}>
						<span className={style.AccountDetailsText}>
							Bank Account Number:
						</span>

						<span className={style.AccountDetailsText}>
							{props.tradeAdInfo.bankAccountNumber}
						</span>
					</div>

					<div className={style.AccountDetailsWrapper}>
						<div className={style.AccountDetailsTextWrapper}>
							<span className={style.AccountDetailsText}>
								Bank Name:
							</span>

							<span className={style.AccountDetailsText}>
								{props.tradeAdInfo.bankName}
							</span>
						</div>


						<div className={style.AccountDetailsTextWrapper}>
							<span className={style.AccountDetailsText}>
								Account Name:
							</span>

							<span className={style.AccountDetailsText}>
								{props.tradeAdInfo.bankAccountName}
							</span>
						</div>
					</div>
				</div>
			</div>


			<div className={style.BankPaymentButtons}>
				<Link to='/transaction-confirmed/8787382'>
					<PrimaryCTA
						ButtonText='Confirm'
					/>
				</Link>

				<PrimaryCTA
					ButtonText='Cancel'
				// clicking on this should run a cancel order function that marks the order as canceled and other processes.

				// also takes the user to home.
				/>
			</div>
		</div>
	)
}


export default BankPayment;